// extracted by mini-css-extract-plugin
module.exports = {"empty":"EmptyTasksList_empty__3fk3E","fading":"EmptyTasksList_fading__2agFZ"};